import { useStaticQuery, graphql } from 'gatsby'

export const useSidebarMenuQuery = () => {
const { allWpMenuItem } = useStaticQuery(
    graphql`
    query SidebarMenuQuery {
      allWpMenuItem(
        filter: {parentDatabaseId: {eq: 0}, locations: {eq: SIDEBAR_MENU}}
      ) {
        nodes {
          id
          label
          path
           cssClasses
          childItems {
            nodes {
              id
              label
              path
              cssClasses
              childItems {
                nodes {
                  id
                  label
                  path
                  cssClasses
                }
              }
              
            }
          }
         
        }
      }
    }
  `
);
return allWpMenuItem;
}